export default angular
  .module("ModifySendToCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifySendToController", [
    "$scope",
    "selectedMessageItem",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "System",
    function (
      $scope,
      selectedMessageItem,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      System,
    ) {
      System.loadUsers((data) => {
        $scope.users = data;
      });
      $scope.sendTo = [...selectedMessageItem.TO_USER];
      const senderId = selectedMessageItem.SENDER_ID;
      $scope.isCreatedByTheLoggedUser = senderId === $rootScope.loggedUser.id;
      $scope.isAddressedToTheLoggedUser = selectedMessageItem.TO_USER
        .find(el => el.TO_USER_ID === $rootScope.loggedUser.id) !== undefined;

      let removableReceiverList = [];
      $scope.sortUsers = [];
      $scope.sortUsers.column = "USER_FULL_NAME";
      $scope.sortUsers.direction = false;

      $scope.checkChecked = userId => $scope.sendTo
        .find(el => el.TO_USER_ID === userId) !== undefined;


      // Sets table sort according to COLUMN
      // Also toggles between ascending and descending
      $scope.changeSorting = function (column) {
        if ($scope.sortUsers.column === column) {
          $scope.sortUsers.direction = !$scope.sortUsers.direction;
        } else {
          $scope.sortUsers.column = column;
          $scope.sortUsers.direction = false;
        }
      };

      $scope.setSendTo = (user) => {
        const checkboxSelected = $scope.users
          .find(el => el.checkbox && el.ID === user.ID) !== undefined;

        const createNewReceiver = ({ ID, USER_FULL_NAME }) => ({
          TO_USER_ID: ID,
          USER_FULL_NAME,
          ASSIGNED: null,
          MESSAGE_ID: selectedMessageItem.ID,
        });


        if (checkboxSelected) {
          $scope.sendTo = [...$scope.sendTo, createNewReceiver(user)];
        } else {
          const filteredSendTo = $scope.sendTo
            .filter(el => el.TO_USER_ID !== user.ID);

          removableReceiverList = [
            ...removableReceiverList,
            $scope.sendTo.filter(el => el.TO_USER_ID === user.ID)[0],
          ].filter(el => el.ID);

          $scope.sendTo = filteredSendTo;
        }
      };

      $scope.ok = () => $modalInstance.close({ action: "add", payload: { sendTo: $scope.sendTo, removableReceiverList } });
      $scope.cancel = () => $modalInstance.dismiss({ action: "cancel", payload: { sendTo: selectedMessageItem.TO_USER } });
    },
  ]);
